import store from "@/store";

export default function (to, from, next) {
  store.commit("temp/setPreviousRoute", from);
  next();
}
